import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@volca/ui/components/ui/stack";
import { cn } from "@volca/ui/lib/utils";
import type { ApEmail } from "@/accounts-payable/types";

const plural = (n: number, word: string) => `${n} ${word}${n === 1 ? "" : "s"}`;

// Invoices first, then the files they came from: one attachment can hold
// several invoices, and some attachments (logos, W-9s) hold none.
export const invoicesCol: ColumnDef<ApEmail> = {
  id: "invoices",
  header: "Invoices",
  meta: { size: "160px" },
  cell: ({ row }) => {
    const { attachments, invoiceCount, receiptCount } = row.original;
    const extracted = invoiceCount + receiptCount;
    // Receipts are named only when there are some, so invoice-only mail reads
    // as it always has.
    const label = [
      (invoiceCount > 0 || receiptCount === 0) &&
        plural(invoiceCount, "invoice"),
      receiptCount > 0 && plural(receiptCount, "receipt"),
    ]
      .filter(Boolean)
      .join(" · ");
    return (
      <Stack align="start" gap={1}>
        <span
          className={cn({
            "text-subtle": extracted === 0,
            "font-medium": extracted > 0,
          })}
        >
          {label}
        </span>
        <span className="text-xs text-subtle">
          from {plural(attachments.length, "attachment")}
        </span>
      </Stack>
    );
  },
};
